class PdpGallery extends HTMLElement {
  constructor() {
    super();
    // Elements
    this.thumbnails = this.querySelectorAll(".fa-pdp-specs__thumbnail");
    this.rawDatas = this.querySelectorAll(".media-data");
    this.parsedData_array = this.parseData();

    this.activeThumbnail = 0;
    this.activeMedia = 0;
    this.allMedia = this.parsedData_array
    .filter(entry => entry.media && Array.isArray(entry.media))
    .flatMap(entry => entry.media);
    this.mediaList = this.allMedia;
    this.media = this.mediaList[this.activeMedia];

    // DOM Elements
    this.navigation = this.querySelector(".fa-pdp-specs__content-navigation");
    this.tabContainer = this.querySelector(".fa-pdp-specs__dropdown");
    this.tabHeader = this.tabContainer?.querySelector("summary span");
    this.tabContents = this.tabContainer?.querySelector(".details__content-inner");

    this.textOverlay = this.querySelector(".fa-pdp-specs__text-overlay");
    this.textOverlayContent = this.querySelector(".fa-pdp-specs__text-overlay-content");
    this.progressBar = this.querySelector(".fa-pdp-specs__progress-bar");
    this.mediaContainer = this.querySelector(".fa-pdp-specs__media");
    this.model = this.mediaContainer?.querySelector("model-viewer");
    this.interactButton = this.querySelector(".fa-pdp-specs__interact");
    this.svgContainer = this.querySelector(".fa-pdp-specs__svg-container");
    this.section = this.closest(".shopify-section");
    this.tableButton = this.section?.querySelector(".pdp-specs__table-button span");
    this.tableContainer = this.section?.querySelector(".pdp-specs__table-container");
    this.tableContent = this.section?.querySelector(".pdp-specs__table");

    // Misc
    this.srcset = [300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1400];
    this.promptShown = false;
    this.startX = 0;
    this.direction = 0;
    this.scrubSensitivity = 0.01;
  }

  connectedCallback() {
    // console.log("INIT PDP gallery", this.parsedData_array);
    this.updateMainContent();
    this.initTabs();
    this.initListeners();
  }

  initListeners() {
    console.log("Init table listener");
    console.log("table", this.tableContent)
    if (this.model) {
      this.model.addEventListener("load", () => {
        this.createHotspot(this.media);
      });
    }

    // Tabs restored
    this.initTabListener();

    if (this.interactButton) {
      this.interactButton.addEventListener("click", this.startInteraction.bind(this));
    }
  
    if (this.tableContainer.offsetHeight >= this.tableContent.offsetHeight) {
      this.tableButton.style.display = "none";
    }

    if (this.tableButton && this.tableContainer) {
      this.tableButton.addEventListener("click", () => {
        const collapsed = this.tableContainer.dataset.state === "collapse";
        this.tableContainer.dataset.state = collapsed ? "expand" : "collapse";
        this.tableButton.textContent = collapsed ? "Hide Specs" : "View All Specs";
      });
    }
  }

  startInteraction() {
    if (!this.model || !this.interactButton) return;

    if (this.interactButton.dataset.action === "stop-interaction") {
      this.model.removeAttribute("interaction-prompt-threshold");
      this.model.setAttribute("interaction-prompt", "none");
      this.model.classList.remove("start-interaction");
      this.interactButton.dataset.action = "start-interaction";
      this.interactButton.querySelector("span").innerHTML = "Interact";
      this.interactButton.setAttribute("aria-label", "Start interacting with the model");
      this.svgContainer.innerHTML = `
        <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
          <path d="M12.6787 0.783203C13.8235 0.783315 14.8725 1.48971 15.7432 2.66797C16.6035 3.83229 17.3021 5.47355 17.7637 7.41016C19.7638 7.86157 21.463 8.56447 22.6699 9.43555C23.8903 10.3164 24.625 11.3845 24.625 12.5518C24.6248 13.7034 23.9098 14.758 22.7188 15.6318C21.5417 16.4953 19.8831 17.1938 17.9277 17.6523C17.5022 19.7907 16.7979 21.6193 15.9053 22.9209C15.0035 24.2358 13.8952 25.0331 12.6787 25.0332C11.4699 25.0332 10.3675 24.2462 9.46875 22.9463C8.57954 21.6601 7.87527 19.8522 7.44531 17.7363C5.3899 17.2949 3.63842 16.5925 2.39355 15.7129C1.13479 14.8234 0.375185 13.7391 0.375 12.5518C0.375 11.3487 1.15454 10.2509 2.44336 9.35449C3.71878 8.46745 5.51173 7.76224 7.6123 7.3291C8.07719 5.41456 8.77527 3.79317 9.63184 2.64355C10.499 1.47994 11.5417 0.783203 12.6787 0.783203ZM11.959 7.90918C10.7372 7.93528 9.57088 8.04893 8.48828 8.23535C8.19626 9.6522 8.03027 11.233 8.03027 12.9082C8.03027 16.1181 8.63683 18.9794 9.57715 21.0029C10.5528 23.1022 11.7154 23.9805 12.6787 23.9805C13.642 23.9803 14.8047 23.1022 15.7803 21.0029C16.1941 20.1123 16.5413 19.0579 16.8027 17.8828C15.4655 18.1202 14.0153 18.2529 12.5 18.2529C12.4017 18.2529 12.3037 18.2502 12.2061 18.249L13.5859 19.6289C13.7915 19.8345 13.7914 20.1674 13.5859 20.373C13.3803 20.5787 13.0474 20.5787 12.8418 20.373L10.1045 17.6357L10.0156 17.5479L12.8418 14.7217C13.0474 14.5163 13.3804 14.5163 13.5859 14.7217C13.7915 14.9273 13.7915 15.2612 13.5859 15.4668L11.8604 17.1904C12.072 17.1959 12.2852 17.1992 12.5 17.1992C15.7099 17.1992 18.5712 16.5927 20.5947 15.6523C22.6936 14.6769 23.572 13.515 23.5723 12.5518C23.5723 11.5884 22.694 10.4258 20.5947 9.4502C19.839 9.09903 18.9652 8.79486 18 8.55078C18.2377 9.87044 18.3716 11.3012 18.3779 12.7969L19.8457 11.3311C20.0513 11.126 20.3844 11.1258 20.5898 11.3311C20.7954 11.5367 20.7954 11.8706 20.5898 12.0762L17.7637 14.9023L17.6758 14.8135L14.9385 12.0762C14.7329 11.8706 14.7329 11.5367 14.9385 11.3311C15.144 11.1259 15.4771 11.1258 15.6826 11.3311L17.3262 12.9756C17.3262 12.9531 17.3271 12.9307 17.3271 12.9082C17.3271 11.2595 17.1653 9.7023 16.8818 8.30273C15.5408 8.04679 14.0613 7.90332 12.5 7.90332L11.959 7.90918ZM7.37207 8.45996C6.25837 8.71736 5.25707 9.05438 4.40527 9.4502C2.30602 10.4258 1.42773 11.5884 1.42773 12.5518C1.428 13.515 2.30636 14.6769 4.40527 15.6523C5.22523 16.0334 6.18407 16.3588 7.24805 16.6123C7.07311 15.4447 6.97754 14.2001 6.97754 12.9082C6.97754 11.3379 7.11799 9.83721 7.37207 8.45996ZM12.6787 1.83594C11.7154 1.83594 10.5528 2.71418 9.57715 4.81348C9.26048 5.49495 8.9837 6.273 8.75293 7.12695C9.93294 6.94788 11.1923 6.85059 12.5 6.85059C13.9469 6.85059 15.3346 6.96918 16.6211 7.18652C16.3873 6.30899 16.1043 5.51085 15.7803 4.81348C14.8047 2.71422 13.642 1.8361 12.6787 1.83594Z" fill="#121212" stroke="#121212" stroke-width="0.25"/>
        </svg>
      `;
    } else {
      this.model.setAttribute("interaction-prompt-threshold", 1000);
      this.model.setAttribute("interaction-prompt", "auto");
      this.model.classList.add("start-interaction");
      this.interactButton.dataset.action = "stop-interaction";
      this.interactButton.setAttribute("aria-label", "Stop interacting with the model");
      this.interactButton.querySelector("span").innerHTML = "Exit";
      this.svgContainer.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
          <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#121212"/>
        </svg>
      `;
    }
  }

  parseData() {
    let data_array = [];
    this.rawDatas.forEach(rawData => {
      if (rawData.textContent.trim() !== "") {
        try {
          data_array.push(JSON.parse(rawData.textContent));
        } catch (e) {
          console.warn("Failed to parse media-data JSON:", e);
        }
      }
    });
    return data_array;
  }

  initTabs() {
    for (let i = 0; i < this.mediaList.length; i++) {
      let stepTitle = `Step ${i + 1}`;
      let e_class = '';
      if (i == 0) {
        e_class = 'active';
      }
      if (this.mediaList[i].title !== undefined) stepTitle = this.mediaList[i].title;
      this.tabContents.innerHTML += this.createTab(stepTitle, i, e_class);
    }
  }

  createTab(title, index, e_class) {
    let mediaSrc = this.mediaList[index].media.split('?')[0].split('/');
    mediaSrc = mediaSrc[mediaSrc.length - 1].replace('.glb','.jpg').replace('_.jpg', '.jpg');
    // https://freakathlete.co/cdn/shop/files/preview_images/HALF_BENCH.jpg?v=1761084896&width=1024

    return `<button data-index="${index}" class="v-stack gap-2 ${e_class}">
      <div class="image-container relative w-full " id="image--" style="padding-top: 100.0%;">
        <img src="//freakathlete.co/cdn/shop/files/preview_images/${mediaSrc}?v=1761084894&amp;width=300" width="100" height="100" loading="lazy" fetch="low" sizes="75px" role="presentation">
      </div>
      <span class="relative">${title}</span>
    </button>`;
  }

  initTabListener() {
    if (!this.tabContents) return;
    const buttons = this.tabContents.querySelectorAll("button");
    buttons.forEach(button => {
      button.addEventListener("click", () => {
        const index = parseInt(button.dataset.index);
        if (!isNaN(index)) {
          this.activeMedia = index;
          this.media = this.mediaList[this.activeMedia];
          this.updateMainContent();

          buttons.forEach(b => b.classList.remove("active"));
          button.classList.add("active");

          if (this.tabContainer) this.tabContainer.removeAttribute("open");
          if (this.tabHeader) this.tabHeader.textContent = button.textContent;
        }
      });
    });
  }

  getSrc() {
    if (!this.media) return;
    let src = this.media.media;
    // if (window.innerWidth < 1000 && this.media.mediaMobile != '') {
    //   src = this.media.mediaMobile;
    // }
    this.source = src.startsWith("//") ? "https:" + src : src;
  }

  updateModel() {
    if (!this.model) return;
    this.model.src = this.source;
    this.model.style.display = "";
    // this.model.play();
  }

  updateMainContent() {
    if (!this.media) return;
    this.getSrc();
    this.updateModel();
    this.createHotspot();
    this.updateTextOverlay();
  }

  createHotspot() {
    if (!this.model) return;
    this.model.innerHTML = "";
    for (let i = 1; i <= 5; i++) {
      let label_h = `hotspot_label_${i}`;
      let position_h = `hotspot_position_${i}`;
      let normal_h = `hotspot_normal_${i}`;
      let modal_h = `hotspot_modal_${i}`;

      if (this.media[label_h]) {
        let measurements = this.media[label_h].split("||");
        this.model.innerHTML += `
          <div slot="hotspot-${i}" data-position="${this.media[position_h]}" data-normal="${this.media[normal_h]}" class="hotspot" role="button" aria-controls="${this.media[modal_h]}" aria-expanded="false" aria-haspopup="dialog" tabIndex="0">
            <span class="metric hotspot-label" data-unit-value="metric">${measurements[1] || ""}</span>
            <span class="imperial hotspot-label" data-unit-value="imperial">${measurements[0] || ""}</span>
          </div>`;
      }
    }
  }

  updateTextOverlay() {
    if (!this.textOverlayContent) return;
    this.textOverlayContent.innerHTML = "";
    if (!this.media) return;

    let textClass = this.media.tab ? "text-center" : "";
    if (this.media.title && !this.media.tab) {
      this.textOverlayContent.innerHTML += `<p class="h4">${this.media.title}</p>`;
    }
    if (this.media.description) {
      this.textOverlayContent.innerHTML += `<p class="text-xs ${textClass}">${this.media.description}</p>`;
    }
  }
}

customElements.define("pdp-gallery", PdpGallery);
